import React, { Component } from 'react';
import cx from 'classnames';

import tripTypesEnum from '../../constants/trip-types-enum';
import TRIP_TYPES_MAP_SIMPLE from '../../constants/trip-types-map-simple';

import { withWindow } from '../../decorators/window';
import TranslatedCopy from '../../intl/translated-copy';
import * as BookerActions from '../../../redux/actions/booking/booker-action-creators';
import { ReservaE4 } from '../../../routing/urls';

class BookerTripSwitch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tripType: 'ROUND_TRIP',
    };
  }

  /* Rendering */

  render() {
    return (
      <div className='Popup Popup--left BookerSelect-popup BookerSelect-popup--tripTypeSelector'>
        { this.renderPopupContent() }
      </div>
    );
  }

  renderButtonText() {
    const { tripType } = this.state;

    return (
      <span>
        <TranslatedCopy copyID={ TRIP_TYPES_MAP_SIMPLE[tripType].copyID } />
        <span className='Icon Icon--arrowSmallDown' />
      </span>
    );
  }

  /**
   * @param {Function} toggleActive - @withOutsideClickListener function
   * passed down from BookerSelect
   */
  renderPopupContent( ) {
    const { tripType } = this.state;
    let tripTypesArray = [];

    tripTypesArray = Object.keys(TRIP_TYPES_MAP_SIMPLE);

    return tripTypesArray.map((type, i) => {
      const button = TRIP_TYPES_MAP_SIMPLE[type];
      const classes = cx({
        'BookerTripSelector-button': true,
        'BookerTripSelector-button--active': tripType === type,
      });

      return (
        <button
          className={ classes }
          key={ i }
          onClick={ () => this.handleChangeTripType(type) }
        >
          <span className='BookerTripSelector-buttonTitle'>
            <TranslatedCopy copyID={ button.copyID } />
          </span>
        </button>
      );
    });
  }

  /* Event Handlers */

  handleChangeTripType(type) {
    const {
      country,
      dispatch,
      goToBookpage,
      language,
    } = this.props;

    dispatch(BookerActions.changeTripType(type));

    this.setState({ tripType: type });

    // In FlightBooker on home page, when selecting multi-city,
    // redirect user to the BOOK_FLIGHT page for multi-city selection
    if (type === tripTypesEnum.MULTI_DESTINATION && goToBookpage  ) {
      const host = window.location.host;
      const locationReservaE4 = ReservaE4(language, country);
      const protocol = window.location.protocol;
      const urlBookingMulticity = `${protocol}//${host}/${locationReservaE4}`;
  
      window.location.href = urlBookingMulticity;
    }
  }
}

export default withWindow(BookerTripSwitch);


